import { REST_API } from '../../constants/restApiUrls';
import HttpConnection from '../../utils/http-connection';

export default function getMe() {
  const httpConnection = new HttpConnection();

  return httpConnection
    .get(REST_API.USER.ME)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}
